/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
export const VALID_DATA_FORMAT_VALUES = ['channelsFirst', 'channelsLast'];
export const VALID_INTERPOLATION_FORMAT_VALUES = ['nearest', 'bilinear'];
export const VALID_PADDING_MODE_VALUES = ['valid', 'same', 'causal'];
export const VALID_POOL_MODE_VALUES = ['max', 'avg'];
export const VALID_BIDIRECTIONAL_MERGE_MODES = ['sum', 'mul', 'concat', 'ave'];
export const VALID_SAMPLE_WEIGHT_MODES = ['temporal'];
//# sourceMappingURL=common.js.map